<app-loader></app-loader>

<div class="flex flex-column w-full" style="height: 100vh;">
    <div *ngIf="!isProduction" class="top-banner-danger">Atención! Estás conectado al entorno de pruebas</div>

    <div class="flex flex-1 w-full" style="min-height: 0;">
        <app-sidebar *ngIf="!is_public_route && is_user_logged"></app-sidebar>
        <div class="flex flex-column w-full" style="min-width: 0; min-height: 0;">
            <app-topbar *ngIf="!is_public_route && is_user_logged"></app-topbar>
            <div class="flex-1" style="min-height: 0; overflow-y: auto;" [class.p-4]="is_user_logged">
                <router-outlet></router-outlet>
            </div>
        </div>
    </div>
</div>

<p-sidebar *ngIf="!is_public_route" #notificationSidebar [(visible)]="notificationsSidebarVisible" position="right" styleClass="w-30rem p-sidebar-content-nopadding">
    <ng-template pTemplate="header">
        <h3 class="m-0">Notificaciones</h3>
    </ng-template>
    <app-notifications-sidebar></app-notifications-sidebar>
</p-sidebar>

<p-sidebar *ngIf="!is_public_route" #listChatsSidebar [(visible)]="listChatsSidebarVisible" (onHide)="onChatListHide()" position="right" styleClass="w-30rem p-sidebar-content-nopadding p-sidebar-footer-nopadding">
    <ng-template pTemplate="header">
        <div>
            <h3 class="m-0">Chats</h3>
        </div>
    </ng-template>
    <app-chat-list></app-chat-list>
</p-sidebar>

<p-sidebar *ngIf="!is_public_route" #chatSidebar [(visible)]="chatSidebarVisible" (onHide)="onChatHide()" position="right" styleClass="w-30rem p-sidebar-content-nopadding p-sidebar-footer-nopadding">
    <ng-template pTemplate="header">
        <div>
            <h3 class="m-0">{{chatTitle}}</h3>
        </div>
    </ng-template>
    <app-chat-detail #chat></app-chat-detail>
</p-sidebar>

<p-sidebar *ngIf="!is_public_route" #phoneSidebar [(visible)]="phoneSidebarVisible" position="right" styleClass="w-30rem p-sidebar-content-nopadding">
    <ng-template pTemplate="header">
        <h3 class="m-0">Teléfono</h3>
    </ng-template>
    <app-phone-sidebar></app-phone-sidebar>
</p-sidebar>


<p-toast></p-toast>

<!--<audio id="localAudio" src="/assets/audio/ringtone-01.mp3"></audio>
<audio id="remoteAudio" autoplay></audio>-->
<app-phone-call-alert #phoneCallAlert></app-phone-call-alert>